export default __webpack_public_path__ + "static/media/transitions_retangle.dfc6b139.svg";